/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { array, lazy, object, Schema } from '../schema';
import { Balance, balanceSchema } from './balance';

export interface Data3 {
  balance: Balance[];
}

export const data3Schema: Schema<Data3> = object({
  balance: ['Balance', array(lazy(() => balanceSchema))],
});
